import React, { useEffect, useRef, useState } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import search_icon from '../assets/search.svg'
import personSearchIcon from '../assets/person_search.svg'


const VendorSelector = ({ page, searchError, setSearchError, vendorData, handleVendorSelect, device }) => {
  const [inputValue, setInputValue] = useState("");
  const [selected, setSelected] = useState("");
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null); // Create a ref for the dropdown

  const handleOpen = () => {
    setSearchError('')
    setOpen(!open)
  }

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  return (
    <div className={`relative w-full cursor-pointer ${device != "small" && searchError === "Vendor is Required" ? " border-2 border-[#EB0728] md:border-none" : ""}`} ref={dropdownRef}>
      <div
        onClick={() => handleOpen()}
        className={` w-full relative z-0 ${device === "small" ? ` ${searchError === "Vendor is Required" || searchError === "Invalid Search" ? "border-2 border-[#EB0728] text-[#EB0728]  md:border-none" : page === 'dashboard' ? "white" : "bg-white"}  w-full rounded-l-[80px]  ${page === 'dashboard' ? "bg-white" : "bg-white  border border-ravgray "}` : "pr-[10px] "}  md:border-none py-[14px] pl-[21px] text-base lg:text-sm  w-full h-[45px] xl:h-[50px]  flex items-center justify-between text-center  font-medium ${!selected && "text-[#707070] font-medium"
          }`}
      >
        {selected
          ? selected?.length > 15
            ? selected?.substring(0, 15) + "..."
            : selected
          :
          <div className={`flex gap-[8px] font-medium text-base lg:text-sm ${searchError?'text-[#EB0728]':''} `}>

            {/* <img src={personSearchIcon} alt="" className={`size-[20px] ${searchError ? "text-[#EB0728]" : "text-black"}`} /> */}
            <svg 
  xmlns="http://www.w3.org/2000/svg" 
  height="24px" 
  viewBox="0 -960 960 960" 
  width="24px" 
  className={`size-[20px] ${searchError ? "text-[#EB0728]" : "text-[#707070]"}`}
  fill="currentColor"
>
  <path d="M440-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm0-80q33 0 56.5-23.5T520-640q0-33-23.5-56.5T440-720q-33 0-56.5 23.5T360-640q0 33 23.5 56.5T440-560ZM884-20 756-148q-21 12-45 20t-51 8q-75 0-127.5-52.5T480-300q0-75 52.5-127.5T660-480q75 0 127.5 52.5T840-300q0 27-8 51t-20 45L940-76l-56 56ZM660-200q42 0 71-29t29-71q0-42-29-71t-71-29q-42 0-71 29t-29 71q0 42 29 71t71 29Zm-540 40v-111q0-34 17-63t47-44q51-26 115-44t142-18q-12 18-20.5 38.5T407-359q-60 5-107 20.5T221-306q-10 5-15.5 14.5T200-271v31h207q5 22 13.5 42t20.5 38H120Zm320-480Zm-33 400Z"/>
</svg>

            Vendor
          </div>}
        {/* {device === "small" ?
          <button className=' absolute z-20 right-[32px] w-full max-w-[52px] h-[52px] rounded-r-[80px] flex items-center justify-center bg-[#0079FF] hover:opacity-70 transform transition-all ease-in-out duration-300'><img src={search_icon} alt="search_icon" className=' w-[18.75px] h-[18.75px]' /></button>
          // : <BiChevronDown color="#707070" size={40} className={`${open && "rotate-180"}`} />
          : null} */}
      </div>
      <ul
        className={` shadow-input w-full bg-white mt-2 overflow-y-auto flex flex-col absolute rounded-md z-50 text-start ${open ? " h-[30vh]" : "max-h-0"
          } `}
      >
        <div className="flex items-center px-2 sticky top-0 bg-white text-base lg:text-sm">
          <AiOutlineSearch size={18} className="text-gray-700" />
          <input
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value.toLowerCase())}
            placeholder="Enter vendor name"
            className="placeholder:text-[#707070] p-2 outline-none"
          />
        </div>
        {vendorData
          ?.sort((a, b) => a?.vendor_name?.localeCompare(b?.vendor_name)) // Sort vendors alphabetically
          ?.map((vendor) => (
            <li
              key={vendor?.vendor_id}
              className={`p-2 text-base lg:text-sm hover:bg-sky-600 hover:text-white
        ${vendor?.vendor_name?.toLowerCase() === selected?.toLowerCase() && "bg-sky-600 text-white"}
        ${vendor?.vendor_name?.toLowerCase().startsWith(inputValue) ? "block" : "hidden"}
      `}
              onClick={() => {
                if (vendor?.vendor_name?.toLowerCase() !== selected.toLowerCase()) {
                  setSelected(vendor?.vendor_name);
                  handleVendorSelect(vendor?.vendor_name);
                  setOpen(false);
                  setInputValue("");
                }
              }}
            >
              {vendor?.vendor_name}
            </li>
          ))}

      </ul>
    </div>
  );
};

export default VendorSelector;